import { createContext, useContext, ReactNode } from 'react';

type VerticalTabsContextValue = {
  verticalTab: string | null;
  setVerticalTab: (tab: string | null) => void;
};

const VerticalTabsContext = createContext<VerticalTabsContextValue | null>(
  null,
);

export const VerticalTabsProvider = ({
  children,
  verticalTab,
  setVerticalTab,
}: {
  children: ReactNode;
  verticalTab: string | null;
  setVerticalTab: (tab: string | null) => void;
}) => {
  return (
    <VerticalTabsContext.Provider value={{ verticalTab, setVerticalTab }}>
      {children}
    </VerticalTabsContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useVerticalTabsContext = () => {
  return useContext(VerticalTabsContext);
};
